export const PLOT_ACL_ACTIONS = ['Kick', 'PlotBan', 'PlotAclBan'] as const;
